import App from "./App.vue";
import { createStore } from "vuex";
import { web_cart as cart, token, allergens } from "@monolith/store";
import { createApp } from "vue";
import { enduserApi } from "@monolith/helpers";
import Notifications from "@kyvg/vue3-notification";
import * as Sentry from "@sentry/vue";
import { hours } from "@monolith/helpers";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPhone,
  faEdit,
  faPlus,
  faMinus,
  faSave,
  faTrash,
  faBars,
  faSort,
  faCircleMinus,
  faCirclePlus,
  faChevronDown,
  faChevronUp,
  faGripHorizontal,
  faGripLines,
  faCamera,
  faBackward,
  faCartShopping,
  faTag,
  faFileInvoiceDollar,
  faUser,
  faUserAstronaut,
  faGift,
  faEnvelope,
  faArrowRight,
  faArrowLeft,
  faXmark,
  faGear,
  faExclamationTriangle,
  faCircleExclamation,
  faSun,
  faMoon,
  faCircleHalfStroke,
  faShop,
  faMoneyBillTrendUp,
  faRightFromBracket,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faPhone,
  faEdit,
  faPlus,
  faMinus,
  faSave,
  faTrash,
  faBars,
  faSort,
  faCircleMinus,
  faCirclePlus,
  faChevronDown,
  faChevronUp,
  faGripHorizontal,
  faGripLines,
  faCamera,
  faBackward,
  faCartShopping,
  faTag,
  faFileInvoiceDollar,
  faUser,
  faUserAstronaut,
  faGift,
  faEnvelope,
  faArrowRight,
  faArrowLeft,
  faXmark,
  faGear,
  faExclamationTriangle,
  faCircleExclamation,
  faSun,
  faMoon,
  faCircleHalfStroke,
  faShop,
  faMoneyBillTrendUp,
  faRightFromBracket,
  faClock,
);

import { createRouter, createWebHistory } from "vue-router";
//import loggingPlugin from "@/plugins/loggingPlugin";
//import { createLogger } from 'vuex'

const Store = () => import("./components/Store/Store.vue");
const NotFound = () => import("./components/Store/NotFound.vue");
const Cart = () => import("./components/Store/Cart.vue");
const PasswordReset = () => import("./components/Auth/PasswordReset.vue");

const store = createStore({
		modules: { token: token, cart: cart, allergens: allergens },
  //plugins: [createLogger()];
});

//const Cart = () => import('./components/Store/Cart.vue');

const router = new createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes: [
    { path: "/", name: "Home", component: Store, meta: { requiresAuth: false } },
    { path: "/404", name: "404", component: NotFound, meta: { requiresAuth: false } },
    { path: "/cart", component: Cart, meta: { requiresAuth: true } },
    { path: "/store", component: Store, meta: { requiresAuth: false } },
    { path: "/store/:category/:product", component: Store, meta: { requiresAuth: false } },
    { path: "/web/:id", component: Store, meta: { requiresAuth: false } },
    { path: "/web/:id/checkout", component: Store, meta: { requiresAuth: false } },
    { path: "/web", component: Store, meta: { requiresAuth: false } },
    { path: "/web/:category/:product", component: Store, meta: { requiresAuth: false } },
    { path: "/web/:id/:category/:product", component: Store, meta: { requiresAuth: false } },
    { path: "/user/reset/:token", name: "PasswordReset", component: PasswordReset, meta: { requiresAuth: false } },
  ],
});

export default store;

const isWebStore = async (id) => {
	await store.commit("setWebStoreMutation", true);
	console.log(enduserApi);
  return await enduserApi.getSite(id);
};

router.beforeEach(async (to, from, next) => {
  if (to.path === "/404") {
    return next();
  }

  let url = window.location.host.split(".");
  if (url[1] == "web") {
    to.params.id = url[0];
    await isWebStore(url[0]);
    return next();
  } else if (to.params.id) {
    await isWebStore(to.params.id);
    if (store.getters.webStore) {
      return next();
    } else {
      return next({ name: "404" });
    }
  }
  // return next({name: "404"});
});

const app = createApp(App);

app.config.globalProperties.$hours = hours;
Sentry.init({
  app,
  dsn: "https://9b3a6f84bb430c86b56898fca7497078@o4505633539489792.ingest.sentry.io/4505633543880704",
  /***integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],***/
  // Session Replay
  replaysSessionSampleRate: 0.05, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(Notifications).use(router).use(store).component("font-awesome-icon", FontAwesomeIcon).mount("#app");
//app.use(loggingPlugin);
